export { defaultProps, NumberInput } from './NumberInput'
